import CallbotContextPadProvider from "./CallbotContextPadProvider";

export default {
  __init__: ['contextPadProvider'],
  contextPadProvider: ['type', CallbotContextPadProvider],
};
